import { render, staticRenderFns } from "./InspectorCreate.vue?vue&type=template&id=5aa349f7&scoped=true"
import script from "./InspectorCreate.vue?vue&type=script&lang=js"
export * from "./InspectorCreate.vue?vue&type=script&lang=js"
import style0 from "./InspectorCreate.vue?vue&type=style&index=0&id=5aa349f7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa349f7",
  null
  
)

export default component.exports